export const limitText = (text: string, digitsLimit: number) => {
  return text.length > digitsLimit ? text.substring(0, digitsLimit).concat('...') : text;
}